<template>
  <div>
    <p>
      Our freestanding wall systems incorporate rigidly mounted columns and sturdy wall panels that require no
      back-filling or continuous-length poured footings. Along with various color options, surface texture alternatives
      for both walls and columns include smooth cast, stamped texture, and realistic faux stacked-stone designs.
    </p>
    <carousel item="free-standing-walls" :images="images"></carousel>
  </div>
</template>

<script>
  import Carousel from '@/components/Carousel'

  export default {
    name: 'FreeStandingWalls',
    components: {Carousel},
    data() {
      return {
        images: [
          'free-standing-wall-0.jpeg',
          'free-standing-wall-1.jpeg',
          'free-standing-wall-2.jpeg',
          'free-standing-wall-3.jpeg',
          'free-standing-wall-4.jpeg',
          'free-standing-wall-5.jpeg',
          'free-standing-wall-6.jpeg',
          'free-standing-wall-7.jpeg'
        ]
      }
    }
  }
</script>

<style scoped>

</style>